import { render } from "./BrandProducts.vue?vue&type=template&id=6637f061"
import script from "./BrandProducts.vue?vue&type=script&lang=js"
export * from "./BrandProducts.vue?vue&type=script&lang=js"

import "./BrandProducts.vue?vue&type=style&index=0&id=6637f061&lang=scss"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__